import { useStyles } from '@webapps/styles';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

const VisualField = ({ label, value }) => {
  const { classes } = useStyles(styles);

  return (
    <div className={classes.info}>
      <div className={classes.infoTitle}>
        <FormattedMessage id={label} />
      </div>
      <div className={classes.infoSubTitle}>{value}</div>
    </div>
  );
};

const styles = ({ spacing }) => ({
  info: {
    display: 'flex',
    flexDirection: 'row',
  },
  infoTitle: {
    fontWeight: 600,
    color: '#0183FF',
  },
  infoSubTitle: {
    marginLeft: spacing(1),
  },
});

VisualField.propTypes = {
  value: PropTypes.node,
  label: PropTypes.node,
};

export default VisualField;
